export default "__VITE_PUBLIC_ASSET__323fee20__"